import React from "react";
import { Button, useListContext, useNotify, useRefresh } from "react-admin";
import RefreshIcon from "@material-ui/icons/Refresh";

import { useAsOfDateMode } from "./AsOfDateModeContext";
import { httpClient } from "../../../api/httpClient";

export const AsOfDateModeActions = () => {
	const { isAsOfDateMode } = useAsOfDateMode();
	const { filterValues } = useListContext();
	const notify = useNotify();
	const refresh = useRefresh();
	const [loading, setLoading] = React.useState(false);

	if (!isAsOfDateMode) {
		return null;
	}

	const handleRecalculate = async () => {
		const asOfDate = filterValues?.as_of_date;
		if (!asOfDate) {
			notify("Please select a date first", { type: "warning" });
			return;
		}

		setLoading(true);
		try {
			const response = await httpClient("customer-articles-recalculate", {
				method: "POST",
				body: JSON.stringify({
					as_of_date: asOfDate,
					company_id: filterValues?.company_id || null,
					terminal_id: filterValues?.terminal_id || null,
				}),
			});

			const { deleted, created } = response.json;
			notify(`Recalculated: ${deleted} deleted, ${created} created`, { type: "success" });
			refresh();
		} catch (error) {
			notify(error.message || "Error recalculating articles", { type: "error" });
		} finally {
			setLoading(false);
		}
	};

	return (
		<Button
			label="resources.customer-articles.buttons.recalculate"
			onClick={handleRecalculate}
			disabled={loading || !filterValues?.as_of_date}
		>
			<RefreshIcon />
		</Button>
	);
};
